import { Box, Card, Grid, TextField, Button } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { apiput } from '../../service/api';
import { SectionCard, SectionHeader, FieldRow } from './LeadViewStyles';

const BuilderInformation = ({ data, setUserAction }) => {
  const [formData, setFormData] = useState({ ...data });
  const [isEdited, setIsEdited] = useState(false);

  useEffect(() => {
    setFormData({ ...data });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setIsEdited(true);
  };

  const handleSave = async () => {
    const result = await apiput(`lead/edit/${data._id}`, formData);
    setUserAction(result);
    if (result.status === 200) {
      toast.success('Lead information updated successfully!');
      setIsEdited(false);
    } else {
      toast.error('Failed to update lead information.');
    }
  };

  return (
    <div>
      <Card style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px" }}>
        <Box p={3}>
          {/* Sales Agent Information */}
          <SectionCard>
            <SectionHeader>Sales Agent</SectionHeader>
            <FieldRow>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Sales Agent Code"
                  name="salesAgentCode"
                  value={formData.salesAgentCode || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Agent Name"
                  name="agentName"
                  value={formData.agentName || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Agent Phone"
                  name="agentPhone"
                  value={formData.agentPhone || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Loan Officer"
                  name="loanOfficer"
                  value={formData.loanOfficer || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Builder Contact */}
          <SectionCard>
            <SectionHeader>Builder Contact</SectionHeader>
            <FieldRow>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="First Name"
                  name="builderFirstName"
                  value={formData.builderFirstName || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Last Name"
                  name="builderLastName"
                  value={formData.builderLastName || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  name="builderEmail"
                  value={formData.builderEmail || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Mobile Phone"
                  name="builderMobilePhone"
                  value={formData.builderMobilePhone || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Property Details */}
          <SectionCard>
            <SectionHeader>Property Details</SectionHeader>
            <FieldRow>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Subject Address"
                  name="subjectAddress"
                  value={formData.subjectAddress || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Subject Property Zip"
                  name="subjectPropertyZip"
                  value={formData.subjectPropertyZip || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Community"
                  name="community"
                  value={formData.community || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="LOT #"
                  name="lotNumber"
                  value={formData.lotNumber || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Sales Price"
                  name="salesPrice"
                  value={formData.salesPrice || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Will the price change?"
                  name="priceChange"
                  value={formData.priceChange || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Est Completion Date"
                  name="completionDate"
                  value={formData.completionDate || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Incentives & Features */}
          <SectionCard>
            <SectionHeader>Incentives & Features</SectionHeader>
            <FieldRow>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Incentive Max Available"
                  name="incentiveMax"
                  value={formData.incentiveMax || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Solar?"
                  name="solar"
                  value={formData.solar || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="HOA 1"
                  name="hoa1"
                  value={formData.hoa1 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="HOA 2"
                  name="hoa2"
                  value={formData.hoa2 || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Home to Sell?"
                  name="homeToSell"
                  value={formData.homeToSell || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Realtor Contact"
                  name="realtorContact"
                  value={formData.realtorContact || ''}
                  fullWidth
                  margin="dense"
                  onChange={handleChange}
                />
              </Grid>
            </FieldRow>
          </SectionCard>

          {/* Notes */}
          <SectionCard>
            <SectionHeader>Notes</SectionHeader>
            <TextField
              label="Helpful Information"
              name="helpfulInfo"
              value={formData.helpfulInfo || ''}
              fullWidth
              margin="dense"
              multiline
              rows={4}
              onChange={handleChange}
            />
          </SectionCard>

          {/* Save Button */}
          <Box display="flex" justifyContent="flex-end" mt={1}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              disabled={!isEdited}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Card>
    </div>
  );
};

export default BuilderInformation;
